import React from 'react';

export const SemiCircleGauge = ({ value, label, max = 10, gradients, targetRef }) => {
  const radius = 80;
  const circumference = radius * Math.PI;
  // Cap percentage to 100% so we don't break the SVG mathematical bounds
  const percentage = Math.min(value / max, 1);
  const strokeDashoffset = circumference - (percentage * circumference);
  
  return (
    <div className="flex flex-col items-center">
      <svg viewBox="0 0 200 120" className="w-full max-w-[180px] drop-shadow-sm">
        <defs>
          <linearGradient id={`${targetRef}-gradient`} x1="0%" y1="0%" x2="100%" y2="0%">
            {gradients.map((g, i) => (
              <stop key={i} offset={g.offset} stopColor={g.color} />
            ))}
          </linearGradient>
        </defs>
        
        {/* Track Background */}
        <path
          d="M 20 100 A 80 80 0 0 1 180 100"
          fill="none"
          stroke="currentColor"
          className="text-muted/20"
          strokeWidth="16"
          strokeLinecap="round"
        />
        
        {/* Animated Fill Path */}
        <path
          d="M 20 100 A 80 80 0 0 1 180 100"
          fill="none"
          stroke={`url(#${targetRef}-gradient)`}
          strokeWidth="16"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          className="transition-all duration-1000 ease-out"
        />
        
        <text x="100" y="85" textAnchor="middle" className="text-4xl font-bold fill-foreground">
          {value}
        </text>
      </svg>
      <span className="text-sm font-medium text-muted-foreground mt-1 text-center">{label}</span>
      <span className="text-[10px] text-muted-foreground/40 mt-1 opacity-0 group-hover:opacity-100 transition-opacity">
        0 - {max} escala
      </span>
    </div>
  );
};
